import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Mail } from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-luxury-navy text-gray-300 border-t-4 border-luxury-gold">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          {/* Company Info */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_timber-decks/artifacts/0s5xkwbn_TBS%20Logo%20-%20timberlake%20flooring.png" 
              alt="Timberlake Flooring Logo" 
              className="h-32 md:h-40 w-auto mb-4"
            />
            <h3 className="text-3xl md:text-4xl font-bold text-white mb-2 luxury-heading tracking-wider">
              TIMBERLAKE <span className="text-luxury-gold">FLOORING</span>
            </h3>
            <p className="text-luxury-gold text-base md:text-lg italic font-light mb-4">Factory Direct</p>
            <div className="w-20 h-px bg-luxury-gold mb-4"></div>
            <p className="text-gray-400 text-sm mb-4 leading-relaxed">
              Proudly serving customers across British Columbia, including the Lower Mainland, Metro Vancouver, Tri-Cities, Fraser Valley, The Interior, and Vancouver Island. Wherever you are in B.C., Timberlake Flooring is here to support your flooring needs.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-2 luxury-heading">Quick Links</h4>
            <div className="w-12 h-px bg-luxury-gold mb-4"></div>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-luxury-gold transition-colors duration-300">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-gray-400 hover:text-luxury-gold transition-colors duration-300">
                  Products
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-luxury-gold transition-colors duration-300">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/resources" className="text-gray-400 hover:text-luxury-gold transition-colors duration-300">
                  Resources
                </Link>
              </li>
              <li>
                <Link to="/visualizer" className="text-gray-400 hover:text-luxury-gold transition-colors duration-300">
                  Room Visualizer
                </Link>
              </li>
              <li>
                <a 
                  href="/become-distributor" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="text-gray-400 hover:text-luxury-gold transition-colors duration-300"
                >
                  Become a Distributor
                </a>
              </li>
            </ul>
          </div>

          {/* Laminate Collections */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-2 luxury-heading">Laminate Flooring</h4>
            <div className="w-12 h-px bg-luxury-gold mb-4"></div>
            <ul className="space-y-2">
              <li>
                <Link to="/products?filter=ComfortSense" className="text-gray-400 hover:text-luxury-gold transition-colors duration-300">
                  ComfortSense
                </Link>
              </li>
              <li>
                <Link to="/products?filter=Guard" className="text-gray-400 hover:text-luxury-gold transition-colors duration-300">
                  Guard
                </Link>
              </li>
            </ul>
          </div>

          {/* Wood Collections */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-2 luxury-heading">Engineered Hardwood</h4>
            <div className="w-12 h-px bg-luxury-gold mb-4"></div>
            <ul className="space-y-2">
              <li>
                <Link to="/products?filter=NatureSense" className="text-gray-400 hover:text-luxury-gold transition-colors duration-300">
                  NatureSense
                </Link>
              </li>
              <li>
                <Link to="/products?filter=Beat" className="text-gray-400 hover:text-luxury-gold transition-colors duration-300">
                  Beat
                </Link>
              </li>
              <li>
                <Link to="/products?filter=Pulse" className="text-gray-400 hover:text-luxury-gold transition-colors duration-300">
                  Pulse
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold text-white mb-2 luxury-heading">Contact Us</h4>
            <div className="w-12 h-px bg-luxury-gold mb-4"></div>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2">
                <MapPin className="w-5 h-5 text-luxury-gold flex-shrink-0 mt-0.5" />
                <span className="text-gray-400 text-sm">
                  13331 Vulcan Wy #9<br />
                  Richmond, BC, V6V 1K4
                </span>
              </li>
              <li className="flex items-center space-x-2">
                <Phone className="w-5 h-5 text-luxury-gold flex-shrink-0" />
                <a href="tel:604-616-3986" className="text-gray-400 hover:text-luxury-gold transition-colors duration-300 text-sm">
                  604-616-3986
                </a>
              </li>
              <li className="flex items-center space-x-2">
                <Mail className="w-5 h-5 text-luxury-gold flex-shrink-0" />
                <a 
                  href="mailto:timberlakebuildingcenter@gmail.com" 
                  className="text-gray-400 hover:text-luxury-gold transition-colors duration-300 text-sm break-all"
                >
                  timberlakebuildingcenter@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-luxury-gold/30 mt-12 pt-8 text-center">
          <p className="text-gray-500 text-sm">
            &copy; {new Date().getFullYear()} <span className="text-luxury-gold">Timberlake Flooring</span>. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
